// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ServiceCard — ficha compacta de un servicio (rejilla y tablero Kanban).
 *
 * Estas reglas vivían dentro de \`WallOutletsList.css\`, pegadas DENTRO del bloque
 * \`.wol-input { ... }\`: el navegador cerraba la llave al llegar a la primera
 * regla con el mismo nivel de anidamiento y descartaba lo de después. Se traen
 * aquí, junto a los componentes que las usan, y con las variables del sistema
 * en lugar de colores fijos (que solo valían en modo claro).
 *
 * Lo importan \`ServiceCard.jsx\` y \`ServiceKanban.jsx\`; webpack sirve la hoja una
 * sola vez aunque se importe dos veces.
 */

/* ── Tablero: barra de desplazamiento fina ──────────────────────────────── */

.svc-kanban-scroll::-webkit-scrollbar {
  height: 6px;
}

.svc-kanban-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.svc-kanban-scroll::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 3px;
}

.svc-kanban-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--slate-300);
}

/* ── Ficha ─────────────────────────────────────────────────────────────── */

.svc-card-hover:hover {
  box-shadow: var(--shadow-md);
  border-color: rgba(var(--accent-rgb), 0.55);
}

.svc-card-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}

.svc-card-action:hover {
  background: var(--bg-toolbar);
  color: var(--text-primary);
}

.svc-card-action--delete:hover {
  background: rgba(220, 38, 38, 0.12);
  color: var(--red-600);
}
`, "",{"version":3,"sources":["webpack://./src/components/ServiceCard.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF,8EAA8E;;AAE9E;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,6EAA6E;;AAE7E;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB","sourcesContent":["/**\r\n * ServiceCard — ficha compacta de un servicio (rejilla y tablero Kanban).\r\n *\r\n * Estas reglas vivían dentro de `WallOutletsList.css`, pegadas DENTRO del bloque\r\n * `.wol-input { ... }`: el navegador cerraba la llave al llegar a la primera\r\n * regla con el mismo nivel de anidamiento y descartaba lo de después. Se traen\r\n * aquí, junto a los componentes que las usan, y con las variables del sistema\r\n * en lugar de colores fijos (que solo valían en modo claro).\r\n *\r\n * Lo importan `ServiceCard.jsx` y `ServiceKanban.jsx`; webpack sirve la hoja una\r\n * sola vez aunque se importe dos veces.\r\n */\r\n\r\n/* ── Tablero: barra de desplazamiento fina ──────────────────────────────── */\r\n\r\n.svc-kanban-scroll::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n\r\n.svc-kanban-scroll::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.svc-kanban-scroll::-webkit-scrollbar-thumb {\r\n  background: var(--border);\r\n  border-radius: 3px;\r\n}\r\n\r\n.svc-kanban-scroll::-webkit-scrollbar-thumb:hover {\r\n  background: var(--slate-300);\r\n}\r\n\r\n/* ── Ficha ─────────────────────────────────────────────────────────────── */\r\n\r\n.svc-card-hover:hover {\r\n  box-shadow: var(--shadow-md);\r\n  border-color: rgba(var(--accent-rgb), 0.55);\r\n}\r\n\r\n.svc-card-action {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  border: 0;\r\n  border-radius: var(--radius-md);\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  transition: background-color 0.12s ease, color 0.12s ease;\r\n}\r\n\r\n.svc-card-action:hover {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.svc-card-action--delete:hover {\r\n  background: rgba(220, 38, 38, 0.12);\r\n  color: var(--red-600);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
